<template>
  <div>
    <el-form
      ref="kechengxinxiForm"
      :model="kechengxinxiForm"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="keChengName"
            label="课程名称"
          >
            <el-input
              v-model="kechengxinxiForm.keChengName"
              size="small "
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="keChengDictKey"
            label="课程类型"
          >
            <el-select
              v-model="kechengxinxiForm.keChengDictKey"
              clearable
              placeholder="请选择课程类型"
              size="small"
            >
              <el-option
                v-for="item in comboxDataKeChengType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-button
              type="primary"
              size="small"
              @click="showAddComboxData('D08','课程类型')"
            >
              自定义
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="shouKeDictKey"
            label="授课方式"
          >
            <el-select
              v-model="kechengxinxiForm.shouKeDictKey"
              clearable
              filterable
              placeholder="请选择授课方式"
              size="small"
            >
              <el-option
                v-for="item in comboxDataShouKeFangShiType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-button
              type="primary"
              size="small"
              @click="showAddComboxData('D09','授课方式')"
            >
              自定义
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="jueSeDictKey"
            label="角色"
          >
            <el-select
              v-model="kechengxinxiForm.jueSeDictKey"
              clearable
              filterable
              placeholder="请选择角色"
              size="small"
            >
              <el-option
                v-for="item in comboxDataJiaoSeType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-button
              type="primary"
              size="small"
              @click="showAddComboxData('D11','角色')"
            >
              自定义
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="totalKeShi"
            label="总课时"
          >
            <el-input-number
              v-model="kechengxinxiForm.totalKeShi"
              size="small"
              :min="1"
              :max="100"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="xueZhiDictKey"
            label="学制"
          >
            <el-select
              v-model="kechengxinxiForm.xueZhiDictKey"
              clearable
              filterable
              placeholder="请选择学制"
              size="small"
              style="width: 100% !important;"
            >
              <el-option
                v-for="item in comboxDataXueZhiType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="liLunKeShi"
            label="理论课时"
          >
            <el-input-number
              v-model="kechengxinxiForm.liLunKeShi"
              size="small"
              :min="1"
              :max="100"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="shiJianKeShi"
            label="实践课时"
          >
            <el-input-number
              v-model="kechengxinxiForm.shiJianKeShi"
              size="small"
              :min="1"
              :max="100"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="nianJi"
            label="年级"
          >
            <el-date-picker
              v-model="kechengxinxiForm.nianJi"
              type="date"
              placeholder="请选择年级"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              size="small"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="zhuanYeDictKey"
            label="专业"
          >
            <el-select
              v-model="kechengxinxiForm.zhuanYeDictKey"
              clearable
              filterable
              placeholder="请选择授课专业"
              size="small"
            >
              <el-option
                v-for="item in comboxDataZhuanYeType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-button
              type="primary"
              size="small"
              @click="showAddComboxData('D10','专业')"
            >
              自定义
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="kaiShiRiQi"
            label="开始日期"
          >
            <el-date-picker
              v-model="kechengxinxiForm.kaiShiRiQi"
              type="date"
              placeholder="请选择开始日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              size="small"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="jieShuRiQi"
            label="结束日期"
          >
            <el-date-picker
              v-model="kechengxinxiForm.jieShuRiQi"
              type="date"
              placeholder="请选择结束日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              size="small"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="jiaoXueZuZhang"
            label="教学组长"
          >
            <el-input
              v-model="kechengxinxiForm.jiaoXueZuZhang"
              size="small "
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="jiaoXueZuZhang"
            label="教学助理"
          >
            <el-select
              v-model="selectedValue"
              size="small"
              multiple
              style="width: 100% !important;"
            >
              <el-option
                v-for="item in kechengxinxiForm.assitantList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="xueYuanShu"
            label="学员数"
          >
            <el-input-number
              v-model="kechengxinxiForm.xueYuanShu"
              size="small"
              :min="1"
              :max="100"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="remarks"
            label="备注"
          >
            <el-input
              v-model="kechengxinxiForm.remarks"
              type="textarea"
              size="small"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="dialog-footer">
      <el-button
        type="primary"
        @click="submitKechengxinxiForm('kechengxinxiForm')"
      >
        保  存
      </el-button>
      <el-button @click="resetForm('kechengxinxiForm')">
        取 消
      </el-button>
    </div>
  </div>
</template>
<script>
import pathReq from '@/api/pathlist'

export default {
  props: {
    postId: { type: Number, default: null }
  },
  data() {
    return {
      kechengxinxiForm: {},
      rules: {
        keChengName: [
          { required: true, message: '请输入课程名称', trigger: 'blur' }
        ],
        keChengDictKey: [
          { required: true, message: '请选择课程类型', trigger: 'change' }
        ],
        shouKeDictKey: [
          { required: true, message: '请选择授课方式', trigger: 'change' }
        ],
        jueSeDictKey: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ],
        xueZhiDictKey: [
          { required: true, message: '请选择学制', trigger: 'change' }
        ],
        zhuanYeDictKey: [
          { required: true, message: '请选择专业', trigger: 'change' }
        ],
        kaiShiRiQi: [
          { required: true, message: '请选择开始日期', trigger: 'change' }
        ]
      },
      comboxDataKeChengType: [],
      comboxDataShouKeFangShiType: [],
      comboxDataZhuanYeType: [],
      comboxDataJiaoSeType: [],
      comboxDataXueZhiType: [],
      selectedValue: []
    }
  },
  computed: {},
  created() {
    pathReq.getComboxDatasByIdArray('D08;D09;D10;D11;D12').then(res => {
      if (res.data.success) {
        const resultData = res.data.result
        this.comboxDataKeChengType = pathReq.comBoxDataFilter(
          resultData,
          'D08'
        ) /** 课程类型 */
        this.comboxDataShouKeFangShiType = pathReq.comBoxDataFilter(
          resultData,
          'D09'
        ) /** 授课方式 */
        this.comboxDataZhuanYeType = pathReq.comBoxDataFilter(
          resultData,
          'D10'
        ) /** 专业 */
        this.comboxDataJiaoSeType = pathReq.comBoxDataFilter(
          resultData,
          'D11'
        ) /** 角色 */
        this.comboxDataXueZhiType = pathReq.comBoxDataFilter(
          resultData,
          'D12'
        ) /** 学制 */
      }
    })

    this.getDetailInfo()
    this.$bus.off('diyComboxData')
    this.$bus.on('diyComboxData', (dictTypeId, result) => {
      switch (dictTypeId) {
        case 'D08':
          this.comboxDataKeChengType = result.allData
          this.kechengxinxiForm.keChengDictKey = result.newId
          break
        case 'D09':
          this.comboxDataShouKeFangShiType = result.allData
          this.kechengxinxiForm.shouKeDictKey = result.newId
          break
        case 'D10':
          this.comboxDataZhuanYeType = result.allData
          this.kechengxinxiForm.zhuanYeDictKey = result.newId
          break
        case 'D11':
          this.comboxDataJiaoSeType = result.allData
          this.kechengxinxiForm.jueSeDictKey = result.newId
          break
      }
    })
  },
  methods: {
    /**
     * 清空表单
     */
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$bus.emit('closeDialog')
    },
    /**
     * 获取详细数据
     */
    getDetailInfo() {
      const path = '/api/services/app/jx01/GetEditjx01?Id=' + this.postId
      pathReq.getNoParams(path).then(res => {
        if (res.data.success) {
          this.kechengxinxiForm = res.data.result.entityData
          this.selectedValue = res.data.result.entityData.jiaoXueZhuLi.split(
            ','
          )
        }
      })
    },
    /**
     * 打开数据字典弹出框
     */
    showAddComboxData(dictTypeId, dictTypeName) {
      this.$bus.emit('comboxData', dictTypeId, dictTypeName)
    },
    /**
     * 新增或者修改身份信息数据
     */
    submitKechengxinxiForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const that = this
          const path = '/api/services/app/jx01/CreateOrUpdatejx01'

          that.kechengxinxiForm.id = this.postId
          that.kechengxinxiForm.jiaoXueZhuLi = this.selectedValue.join(',')

          pathReq
            .dataUpdate(path, { entityData: that.kechengxinxiForm })
            .then(res => {
              if (res.status === 200) {
                if (res.data.success) {
                  that.$message.success('修改课程信息成功！')
                  that.$bus.emit('reloadKeChenXinXi')
                }
              } else {
                that.$message.error('修改课程身份信息失败！')
              }
            })
        }
      })
    }
  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 84% !important;
}
</style>
